import { ActionTypes } from '../../constants/actionTypes/tdmSearch';
import * as tdmSearchService from '../../../services/tdmSearch';
import { fetchAttributeCollection } from '../../../services/attributeCollection';
import { parseDpRoomDistributionString } from '../../../utils/pax/helper';
import { getFittingDepartureDate } from '../../../utils/actionHelper';

const getLabels = async (siteSettings) => {
  const { siteId, alias, baseUrl } = siteSettings;
  let labels = await fetchAttributeCollection(baseUrl, siteId, alias);
  labels = {
    ...labels.paxFieldAndSelect,
    ...labels,
  };
  return labels;
};

const getTdmSearchData = async (siteSettings, searchParams) => {
  const { siteId, baseUrl } = siteSettings;
  const { tdmRuleId } = searchParams;

  return tdmSearchService.getTdmSearchControlData({
    baseUrl,
    siteId,
    tdmRuleId,
  });
};

const initSuccess = (labels, data) => {
  return {
    type: ActionTypes.TDM_SEARCH_CONTROL_INIT_SUCCESS,
    labels,
    data,
  };
};

const initFail = (labels) => {
  return {
    type: ActionTypes.TDM_SEARCH_CONTROL_INIT_FAIL,
    labels,
  };
};

const initFinished = (labels, tdmSearchData, searchParams, siteSettings) => {
  return (dispatch) => {
    const { departureId, departureDate, roomAges, isCruise } = searchParams;
    const { departures } = tdmSearchData || {};

    if (departures?.length > 0) {
      let selectedDepartureAirport = departures.find(airport => airport.itemId === departureId);

      if (!selectedDepartureAirport) {
        selectedDepartureAirport = departures.find(airport => airport.isDefault === true);
      }

      const selectedDepartureDate = getFittingDepartureDate(selectedDepartureAirport, departures[0], departureDate, isCruise
        ? siteSettings.datePicker.cruiseBookDaysAhead : siteSettings.datePicker.cruiseBookDaysAhead);

      const roomDistribution = parseDpRoomDistributionString(roomAges);

      const data = {
        departureAirports: departures,
        selectedDeparture: selectedDepartureAirport || departures[0],
        selectedDepartureDate,
        roomDistribution,
      };

      dispatch(initSuccess(labels, data));
    }
    else {
      dispatch(initFail(labels));
    }
  };
};

export const init = (siteSettings, searchParams) => {
  return async (dispatch) => {
    const [labels, tdmSearchData] = await Promise.all([
      getLabels(siteSettings),
      getTdmSearchData(siteSettings, searchParams),
    ]);

    dispatch(initFinished(labels, tdmSearchData, searchParams, siteSettings));
  }
};

export const changeDepartureAirport = (departureAirport) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.TDM_SEARCH_CONTROL_CHANGE_DEPARTURE_AIRPORT,
      departureAirport,
    });
  };
};

export const changeDepartureDate = (departureDate) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.TDM_SEARCH_CONTROL_CHANGE_DEPARTURE_DATE,
      selectedDepartureDate: departureDate,
    });
  };
};

export const changeRoomDistribution = (roomDistribution, selectedNumberOfRooms) => {
  return {
    type: ActionTypes.TDM_SEARCH_CONTROL_CHANGE_ROOM_DISTRIBUTION,
    roomDistribution,
    selectedNumberOfRooms,
  };
};
